export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Política de privacidade`,
    cloneTitleNoun: `políticas da acomodação`,
    cloneItemNoun: `as políticas`,
    editorHintLang: `Política de privacidade em {label}`,
    optional: `(opcional)`,
    headingOpt1: `Título 1`,
    headingOpt2: `Título 2`,
    headingOpt3: `Título 3`,
    headingNormal: `Normal`,
    tipBold: `Negrito`,
    tipItalic: `Itálico`,
    tipUnderline: `Sublinhado`,
    tipListOrdered: `Lista ordenada`,
    tipListBullet: `Lista com marcadores`,
    tipLink: `Link`,
    tipQuote: `Citação`,
    tipClean: `Limpar formatação`,
    charCount: `{count} caractere | {count} caracteres`,
    saving: `Salvando…`,
    editorPlaceholder: `Escreva aqui a política de privacidade em {label}…`,
    errNoListing: `Anúncio não encontrado.`,
    errLoad: `Não foi possível carregar a política de privacidade.`,
    errEsRequired: `A política em espanhol é obrigatória.`,
    saveSuccess: `Política de privacidade salva com sucesso.`,
    saveError: `Erro ao salvar as políticas.`,
  },
  rooms: {
    bulkTitle: `Criar quartos em lote`,
    bulkSubtitle: `Gere vários quartos para um tipo, com código automático e descrição opcional.`,
    available: `Disponíveis: {count}`,
    willCreate: `Serão criados: {count}`,
    needTypeFirst: `Primeiro crie ao menos um <b>Tipo de quarto</b> para poder gerar quartos.`,
    labelType: `Tipo`,
    selectType: `Selecione um tipo`,
    labelQuantity: `Quantidade`,
    phQuantity: `Ex.: 10`,
    labelPrefix: `Prefixo do código`,
    phPrefix: `Ex.: A- ou 10`,
    optional: `Opcional`,
    labelStart: `Início`,
    labelPadding: `Padding`,
    labelDescription: `Descrição (opcional)`,
    phDescription: `Será aplicada aos quartos criados`,
    nameEqType: `Nome = Tipo`,
    recommended: `(recomendado)`,
    example: `Exemplo:`,
    createBulk: `Criar em lote`,
    typeFallback: `Tipo`,
    previewFormat: `{name} • Código: {code}`,
    noActivePlan: `Você não tem um plano ativo para criar quartos.`,
    limitReached: `Limite atingido: seu plano permite {limit} quartos para esta propriedade.`,
    selectTypeWarn: `Selecione um tipo de quarto.`,
    invalidQuantity: `Informe uma quantidade válida.`,
    cannotAddMore: `Você não pode adicionar mais. Limite: {limit}.`,
    partialCreated: `Foram criados apenas {created} porque seu plano permite {limit} e restavam {remaining}.`,
    planLimitSave: `Seu plano permite {limit} quartos. Você está tentando salvar {count}.`,
  },
  images: {
    zipDownloadTitle: `Baixe todas as imagens da propriedade em um ZIP`,
    zipNoImages: `Não há imagens para baixar`,
    preparing: `Preparando…`,
    downloadImages: `Baixar imagens`,
    loading: `Carregando imagens…`,
    noAccommodations: `Ainda não há acomodações configuradas para esta propriedade.`,
    engineCoverTag: `Capa do motor`,
    imageCount: `{count} imagem | {count} imagens`,
    hotelPhotosDesc: `Fotos gerais (pátio, entrada, recepção…) que o cliente verá ao abrir o motor`,
    dragToOrder: `Arraste para ordenar a galeria`,
    ordering: `Ordenando…`,
    dragTip: `Arrastar`,
    hotelSectionName: `Fotos do hotel · áreas comuns`,
    orderUpdated: `Ordem das imagens atualizada.`,
    orderError: `Não foi possível atualizar a ordem das imagens.`,
    downloadError: `Não foi possível baixar as imagens.`,
  },
};
